import styled from "styled-components";
export const DiscountInfoBox = styled.section `
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	pointer-events: none;

	.descImg {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		max-width: 40%;
		max-height: 9.6%;
		height: auto;
		object-fit: initial !important;
	}

	.discountIcon {
		position: absolute;
		top: 0;
		right: 0;
		max-height: 13%;
		max-width: 40%;
		height: auto;
	}
	.themeTag {
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		max-width: 80%;
		max-height: 9.6%;
		height: fit-content;
		width: auto;
		object-fit: initial !important;
	}
`;
